"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationTypeToJSON = exports.NotificationTypeFromJSONTyped = exports.NotificationTypeFromJSON = exports.NotificationType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var NotificationType;
(function (NotificationType) {
    NotificationType["NFTPROMO"] = "NFT_PROMO";
    NotificationType["PROMOTOKEN"] = "PROMO_TOKEN";
    NotificationType["SPONSOREDCOMPETITIONWINNER"] = "SPONSORED_COMPETITION_WINNER";
    NotificationType["OVERWOLFXPFUELREWARD"] = "OVERWOLF_XP_FUEL_REWARD";
    NotificationType["PRIZEPOOL"] = "PRIZE_POOL";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
function NotificationTypeFromJSON(json) {
    return NotificationTypeFromJSONTyped(json, false);
}
exports.NotificationTypeFromJSON = NotificationTypeFromJSON;
function NotificationTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.NotificationTypeFromJSONTyped = NotificationTypeFromJSONTyped;
function NotificationTypeToJSON(value) {
    return value;
}
exports.NotificationTypeToJSON = NotificationTypeToJSON;
